import React,{ Component } from "react"
import { Button, Carousel, Container, Row, Card, Col } from "react-bootstrap"

const ProjectsSv: React.FC = () => {
        return (
            <div className="projects-section">
              <h2 className="primary-text">OUR PROJECTS</h2>
              <p className="primary-text">Projekt som visar våra senaste arbeten och innovationer. </p>
              <Row>
                <Col md={3}>
                  <Card className="projectSv" style={{ marginBottom: '16px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
                    <Card.Img variant="top" src="/images/villas2.jpg" />
                    <Card.Body>
                      <Card.Title>Projekt A</Card.Title>
                      <Card.Text>
                        En responsiv marknadsföringssida byggd med React.
                      </Card.Text>
                      <Button variant="secondary">View Details</Button>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={3}>
                  <Card className="projectSv" style={{ marginBottom: '16px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
                    <Card.Img variant="top" src="/images/villas.jpg" />
                    <Card.Body>
                      <Card.Title>Projekt A</Card.Title>
                      <Card.Text>
                        En responsiv marknadsföringssida byggd med React.
                      </Card.Text>
                      <Button variant="secondary">View Details</Button>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={3}>
                  <Card className="projectSv" style={{ marginBottom: '16px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
                    <Card.Img variant="top" src="/images/villas2.jpg" />
                    <Card.Body>
                      <Card.Title>Projekt A</Card.Title>
                      <Card.Text>
                        En responsiv marknadsföringssida byggd med React.
                      </Card.Text>
                      <Button variant="secondary">View Details</Button>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={3}>
                  <Card  className="projectSv" style={{ marginBottom: '16px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
                    <Card.Img variant="top" src="/images/villas.jpg" />
                    <Card.Body>
                      <Card.Title>Projekt A</Card.Title>
                      <Card.Text>
                        En responsiv marknadsföringssida byggd med React.
                      </Card.Text>
                      <Button variant="secondary">View Details</Button>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
        )
};

export default ProjectsSv;